module.exports = __webpack_public_path__ + "media/images/cloud-search-e88098c7d5be9881da0d13857409ae79.png";